import { Stack } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import { RefreshCcw01Icon } from '@/components/icons/RefreshCcw01Icon';
import { RefreshCw01Icon } from '@/components/icons/RefreshCw01Icon';
import { COLORS } from '@/styles/tokens/colors';

import { Button } from './Button';
import { IconButton } from './IconButton';

const ICON_SIZE = 16;

const useStyles = makeStyles()(() => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    '& > *:first-of-type': {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
    },
    '& > *:last-of-type': {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
      borderLeft: 'none',
    },
  },
}));

export interface UndoRedoButtonGroupProps {
  onUndo: () => void;
  onRedo: () => void;
  canUndo: boolean;
  canRedo: boolean;
  isCompact?: boolean;
}

export function UndoRedoButtonGroup({
  onUndo,
  onRedo,
  canUndo,
  canRedo,
  isCompact = false,
}: UndoRedoButtonGroupProps) {
  const { classes } = useStyles();

  if (isCompact) {
    return (
      <Stack direction="row" className={classes.root}>
        <IconButton
          variant="secondary"
          size="sm"
          onClick={onUndo}
          disabled={!canUndo}
          icon={RefreshCcw01Icon}
          ariaLabel="Undo"
          sx={{
            '&:disabled': {
              borderColor: COLORS.GRAY[300],
              color: COLORS.GRAY[300],
            },
          }}
        />
        <IconButton
          variant="secondary"
          size="sm"
          onClick={onRedo}
          disabled={!canRedo}
          icon={RefreshCw01Icon}
          ariaLabel="Redo"
          sx={{
            '&:disabled': {
              borderColor: COLORS.GRAY[300],
              color: COLORS.GRAY[300],
            },
          }}
        />
      </Stack>
    );
  }

  return (
    <Stack direction="row" className={classes.root}>
      <Button
        size="sm"
        variant="secondary"
        onClick={onUndo}
        disabled={!canUndo}
        startIcon={RefreshCcw01Icon}
        iconProps={{ size: ICON_SIZE }}
        sx={{
          '&:disabled': {
            borderColor: COLORS.GRAY[300],
            color: COLORS.GRAY[300],
          },
        }}
      >
        Undo
      </Button>
      <Button
        size="sm"
        variant="secondary"
        onClick={onRedo}
        disabled={!canRedo}
        startIcon={RefreshCw01Icon}
        iconProps={{ size: ICON_SIZE }}
        sx={{
          '&:disabled': {
            borderColor: COLORS.GRAY[300],
            color: COLORS.GRAY[300],
          },
        }}
      >
        Redo
      </Button>
    </Stack>
  );
}
